// Shared Nuxt UI `ui` overrides, so every list looks the same.

/** UTable inside a bordered card, with a sticky header. */
export const tableUi = {
  root: 'rounded-lg ring ring-default bg-default overflow-auto',
  base: 'min-w-full',
  thead: 'bg-elevated/50',
  th: 'text-xs font-medium uppercase tracking-wide text-muted py-2.5 px-3 first:ps-4 last:pe-4',
  td: 'py-3 px-3 first:ps-4 last:pe-4 text-toned',
  tr: 'data-[selectable=true]:hover:bg-elevated/50 data-[selectable=true]:cursor-pointer',
  empty: 'py-10',
} as const

/** Hide a column below the given breakpoint (phones get the essentials). */
export function hideBelow(bp: 'sm' | 'md' | 'lg' | 'xl') {
  const cls = { sm: 'hidden sm:table-cell', md: 'hidden md:table-cell', lg: 'hidden lg:table-cell', xl: 'hidden xl:table-cell' }[bp]
  return { class: { th: cls, td: cls } }
}

export const ROLE_COLORS: Record<string, 'error' | 'warning' | 'primary' | 'neutral'> = {
  admin: 'error',
  operator: 'warning',
  coach: 'primary',
  user: 'neutral',
}

/** The column that should soak up spare width and truncate its text. */
export const growColumn = { class: { td: 'max-w-0 w-full', th: 'w-full' } }

/** Avatar with brand-tinted initials. */
export const avatarUi = { root: 'bg-primary/10', fallback: 'text-primary font-medium' }
